// extracted by mini-css-extract-plugin
export default {"cls1":"PayeeUploadStep-StepContent_cls1__XsYSH","cls2":"PayeeUploadStep-StepContent_cls2__pX8Of PayeeUploadStep-StepContent_cls1__XsYSH"};